import { ErrorBoundary } from "@/appComponents/Blocks/Utils/ErrorBoundary/ErrorBoundary";
import { usePlanManagerContext } from "@/providers/PlanManagerProvider";
import { useChartDocumentContext } from "@/providers/ChartDocumentProvider";
import { useWSMgrContext } from "@/providers/WsMgrProvider";

const WsMgrGate = ({ children }) => {
  const { wsMgr } = useWSMgrContext();
  if (!wsMgr?.state) return null;
  return children;
};

const DocumentGate = ({ children }) => {
  const { chartDocument } = useChartDocumentContext();
  if (!chartDocument?.state) return null;
  return children;
};

const PlanningGate = ({ children }) => {
  const { planManager } = usePlanManagerContext();
  if (!planManager?.state) return null;
  return children;
};

/** For components that require planMgr */
export const PlanningBoundary = ({ children }) => (
  <ErrorBoundary fallback={<></>}>
    <WsMgrGate>
      <DocumentGate>
        <PlanningGate>{children}</PlanningGate>
      </DocumentGate>
    </WsMgrGate>
  </ErrorBoundary>
);

/** For components that require doc ref*/
export const DocumentBoundary = ({ children }) => (
  <ErrorBoundary fallback={<></>}>
    <WsMgrGate>
      <DocumentGate>{children}</DocumentGate>
    </WsMgrGate>
  </ErrorBoundary>
);
